import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils.js'

/*
*               他人推荐
                搜索引擎
                Facebook-社交媒体
                推特-社交媒体
                领英-社交媒体
                Youtube-社交媒体
                活动
                其他
            */
export const drainageTypeEnum = new GenerateEnum({
  USER_INVITE: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum0',
      text: '他人推荐',
    }),
    value: 0
  },
  SEARCH_ENGINE: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum1',
      text: '搜索引擎',
    }),
    value: 1
  },
  FACEBOOK: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum2',
      text: 'Facebook-社交媒体',
    }),
    value: 2
  },
  TWITTER: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum3',
      text: '推特-社交媒体',
    }),
    value: 3
  },
  LINKEDIN: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum4',
      text: '领英-社交媒体',
    }),
    value: 4
  },
  YOUTUBE: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum5',
      text: 'Youtube-社交媒体',
    }),
    value: 5
  },
  ACTIVITY: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum6',
      text: '活动',
    }),
    value: 6
  },
  OTHER: {
    label: getLabelText({
      key: 'remote.admin.drainageTypeEnum7',
      text: '其他',
    }),
    value: 7
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/businessClue.js